import { z } from 'zod';

import { BasicFiltersSchema } from '@/entities/listing/typings/api-types';

export const preorderInfoSearchSchema = z.object({
  ...BasicFiltersSchema.shape,
  bookingType: z.union([
    z.literal('your-tour'),
    z.literal('accommodation'),
    z.literal('excursion'),
  ]),
  propertyId: z.string(),
  roomTypeId: z.string(),
  ratePlanId: z.string(),
  checksum: z.string(),
  travelId: z.string().optional(),
  selectedDate: z.string().optional(),
  hasRecommendedExcursions: z.boolean().optional(),
});

export type PreorderInfoSearchSchema = z.infer<typeof preorderInfoSearchSchema>;
